module.exports = __webpack_public_path__ + "img/user-circle.f2a40d79.svg";